'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchUpcomingCatalogsIfNeeded = exports.getLiveCatalogsIds = exports.getUpcomingCatalogIds = exports.LOAD_UPCOMING_CATALOGS_SUCCESS = exports.LOAD_UPCOMING_CATALOGS_REQUEST = exports.LOAD_UPCOMING_CATALOGS_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _reselect = require('reselect');

var _user = require('./user');

var _catalog = require('./catalog');

var _config = require('./config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_UPCOMING_CATALOGS_FAIL = exports.LOAD_UPCOMING_CATALOGS_FAIL = 'la/domain/upcomingCatalogs/LOAD_FAIL';
var LOAD_UPCOMING_CATALOGS_REQUEST = exports.LOAD_UPCOMING_CATALOGS_REQUEST = 'la/domain/upcomingCatalogs/LOAD_REQUEST';
var LOAD_UPCOMING_CATALOGS_SUCCESS = exports.LOAD_UPCOMING_CATALOGS_SUCCESS = 'la/domain/upcomingCatalogs/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

var DEFAULT_STATE = {
    ids: [],
    loaded: 0,
    loading: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_UPCOMING_CATALOGS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_UPCOMING_CATALOGS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_UPCOMING_CATALOGS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                ids: action.payload.catalogs.map(function (catalog) {
                    return catalog.catalogId;
                }).sort(),
                loaded: action.meta.actionTime,
                loading: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.upcomingCatalogs;
};

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getUpcomingCatalogIds = exports.getUpcomingCatalogIds = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.ids;
});

var getLiveCatalogsIds = exports.getLiveCatalogsIds = function getLiveCatalogsIds(state) {
    var allUpcomingCatalogIds = getUpcomingCatalogIds(state);
    return allUpcomingCatalogIds.filter(function (id) {
        var catalog = (0, _catalog.getCatalog)(state, id);
        return catalog.catalogStatus === 'live';
    });
};

var shouldFetchUpcomingCatalogs = function shouldFetchUpcomingCatalogs(state) {
    var items = getUpcomingCatalogIds(state);
    if (items.length) {
        var loaded = loadedSelector(state);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = loadingSelector(state);
    return !loading;
};

/* ACTION CREATORS */
var loadUpcomingCatalogs = function loadUpcomingCatalogs() {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                type: LOAD_UPCOMING_CATALOGS_REQUEST
                            });
                            _context.next = 7;
                            return _api.Catalog.fetchUpcomingCatalogs({
                                authToken: authToken,
                                deployment: deployment
                            });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_UPCOMING_CATALOGS_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: LOAD_UPCOMING_CATALOGS_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchUpcomingCatalogsIfNeeded = exports.fetchUpcomingCatalogsIfNeeded = function fetchUpcomingCatalogsIfNeeded() {
    return function (dispatch, getState) {
        if (shouldFetchUpcomingCatalogs(getState())) {
            return dispatch(loadUpcomingCatalogs());
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/upcomingCatalogs.js
// module id = 39qi
// module chunks = 60